// extracted by mini-css-extract-plugin
export var orderDetails = "_nb-2";
export var orderImage = "_nb-1";
export var orderMeta = "_nb-3";
export var orderSummary = "_nb-0";
export var rightArrow = "_nb-4";